import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { GET_CLEARANCE_DATA } from 'mocks/queries';
import useZipCode from 'global-state/zipCode/useZipCode';
import useWarehouseIdForUser from 'global-state/warehouseIdForUser/useWarehouseIdForUser';
import { useQuery } from '@apollo/client';
import { DEFAULT_WAREHOUSE_ID } from 'commons/constants';
import useIsBrowser from 'hooks/useIsBrowser';
const DEFAULT_VARIABLES = {
  zipCode: '',
  fromCache: true,
  warehouseId: DEFAULT_WAREHOUSE_ID
};

/* Gives all clearance stock (multiple products) for the user's zipcode
 * skipQuery - Allows skipping clearance stock fetch when used conditionally
 */
const useAllProductClearanceStock = t0 => {
  const $ = _c(12);
  const skipQuery = t0 === undefined ? false : t0;
  const zipCode = useZipCode();
  const isBrowser = useIsBrowser();
  const warehouseId = useWarehouseIdForUser();
  let t1;
  if ($[0] !== isBrowser || $[1] !== warehouseId || $[2] !== zipCode) {
    t1 = isBrowser ? {
      zipCode,
      fromCache: true,
      warehouseId
    } : DEFAULT_VARIABLES;
    $[0] = isBrowser;
    $[1] = warehouseId;
    $[2] = zipCode;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== skipQuery || $[5] !== t1) {
    t2 = {
      variables: t1,
      skip: skipQuery
    };
    $[4] = skipQuery;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const {
    loading,
    data
  } = useQuery(GET_CLEARANCE_DATA, t2);
  data?.clearanceData?.data;
  let t3;
  if ($[7] !== data?.clearanceData?.data) {
    t3 = data?.clearanceData?.data || {};
    $[7] = data?.clearanceData?.data;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const clearanceData = t3;
  const t4 = loading && !data;
  let t5;
  if ($[9] !== clearanceData || $[10] !== t4) {
    t5 = {
      data: clearanceData,
      error: null,
      loading: t4
    };
    $[9] = clearanceData;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export default useAllProductClearanceStock;